import React, { useContext, useEffect } from "react";
import { Segment, Grid, Label } from "semantic-ui-react";
import BreadcrumbContainer from "../../../app/common/breadcrumb/BreadcrumbContainer";
import Step1 from "./Step1";
import { RootStoreContext } from "../../../app/stores/rootStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { observer } from "mobx-react-lite";
import Step2 from "./Step2";
import Step3 from "./Step3";

interface IProps {
  sections: any[];
}
const DashboardDian: React.FC<IProps> = ({ sections }) => {
  document.title = "Set de pruebas";
  const rootStore = useContext(RootStoreContext);
  const { getTestSetStatus, loadTestSet } = rootStore.companyStore;
  useEffect(() => {
    getTestSetStatus();
  }, [getTestSetStatus]);

  if (!loadTestSet) {
    return <LoadingComponent content="Cargando Set de pruebas" />;
  }

  return (
    <div className="configurationContent">
      <BreadcrumbContainer title="Set de pruebas Dian" sections={sections} />
      <Segment padded="very">
        <Grid columns={2} stackable>
          <Grid.Row>
            <Grid.Column>
              <Segment padded="very" className="stepsp">
                <Label className="steps" color="green" floating size="big">
                  1
                </Label>
                <Step1/>
              </Segment>
            </Grid.Column>
            <Grid.Column>
              <Segment padded="very" className="stepsp">
                <Label className="steps" color="green" floating size="big">
                  2
                </Label>
                <Step2/>
              </Segment>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              <Segment padded="very" className="stepsp">
                <Label className="steps" color="green" floating size="big">
                  3
                </Label>
                <Step3/>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </div>
  );
};

export default observer(DashboardDian);
